export default __webpack_public_path__ + "static/media/Questionnaires.8d146659.jpg";